<ion-toolbar
  mode="ios"
  class="part-1"
  [style]="{ '--background': headerColor }"
>
  <div style="display: flex; flex-direction: row">
    <div class="image-container">
      <img [src]="logo" alt="" />
      <div>
        <p [style]="{ color: menuColor }">
          {{
            (isCurrentCheckin
              ? "SHARED_TEXT.HEADER.CURRENT_CHECK_IN"
              : "SHARED_TEXT.HEADER.DASHBOARD"
            ) | translate
          }}
        </p>
      </div>
    </div>
  </div>
  <ion-buttons slot="end">
    <ion-button size="small" fill="clear" (click)="checkByQrCode()">
      <ion-icon
        class="scan-icon"
        slot="icon-only"
        src="./assets/icon/qrscan.svg"
      ></ion-icon>
    </ion-button>
  </ion-buttons>
</ion-toolbar>

<ion-item
  class="checked-in-status-view"
  [ngClass]="{ 'remove-padding': shouldShowNavigationPlaceBtns() }"
  lines="none"
  [style]="{ '--background': subMenuColor }"
  (click)="showCheckedInPlace()"
>
  <ion-button
    *ngIf="shouldShowNavigationPlaceBtns()"
    slot="start"
    class="arrow-button left"
    size="small"
    fill="clear"
    (click)="previousPlace()"
  >
    <ion-icon
      *ngIf="shouldShowNavigationPlaceBtns(1)"
      slot="icon-only"
      name="chevron-back-outline"
    ></ion-icon>
  </ion-button>

  <div
    slot="start"
    class="status-circle"
    [ngClass]="{ 'checked-in': checkedIn }"
  ></div>

  <ion-label [style]="{ color: menuColor }">
    <ng-container *ngIf="checkedIn; else notCheckedIn">
      {{ "SHARED_TEXT.HEADER.CHECKED_IN" | translate }}:
      <ng-container *ngIf="!isCurrentCheckin">
        &nbsp;
        {{
          checkedPlaces.length == 1
            ? checkedPlaces[0].entityName
            : "to " + checkedPlaces.length + " places"
        }}
      </ng-container>
      <ng-container *ngIf="isCurrentCheckin">
        &nbsp; {{ sharedDataService.currentSelectedCheckinPlace?.entityName }}
      </ng-container>
    </ng-container>
    <ng-template #notCheckedIn>{{
      "SHARED_TEXT.HEADER.YOU_ARENT_CHECKED_IN" | translate
    }}</ng-template>
  </ion-label>

  <ng-container *ngIf="checkedIn && checkedPlaces.length === 1">
    <ion-button
      slot="end"
      size="small"
      fill="clear"
      class="checkin-view-btn"
      (click)="checkoutPlace(checkedPlaces[0], $event)"
    >
      <ion-icon
        slot="icon-only"
        src="./assets/icon/checkout-light.svg"
      ></ion-icon>
    </ion-button>
  </ng-container>

  <ion-button
    *ngIf="shouldShowNavigationPlaceBtns()"
    slot="end"
    class="arrow-button right"
    size="small"
    fill="clear"
    (click)="nextPlace()"
  >
    <ion-icon
      *ngIf="shouldShowNavigationPlaceBtns(2)"
      slot="icon-only"
      name="chevron-forward-outline"
    ></ion-icon>
  </ion-button>
</ion-item>

<div
  class="check-in-places-list-container"
  *ngIf="showCheckedInPlacesList"
  (click)="showCheckedInPlacesList = false"
>
  <div class="list-container">
    <ion-list
      class="check-in-places-list"
      lines="none"
      (click)="$event.stopImmediatePropagation(); $event.stopPropagation()"
    >
      <ion-item
        *ngFor="let place of checkedPlaces"
        [ngClass]="{
          selected:
            selectedPlace &&
            selectedPlace.userCheckInDetailID === place.userCheckInDetailID
        }"
        (click)="placeChoose(place)"
      >
        <ion-label>{{ place.entityName }}</ion-label>
        <ion-button
          slot="end"
          size="small"
          fill="clear"
          class="checkin-view-btn"
          (click)="checkoutPlace(place, $event)"
        >
          <ion-icon
            slot="icon-only"
            src="./assets/icon/checkout-dark.svg"
          ></ion-icon>
        </ion-button>
      </ion-item>
    </ion-list>
  </div>
</div>

<div
  class="checkin-btns"
  [style]="{ background: headerColor }"
  *ngIf="!hideCheckinButton"
>
  <ion-button
    [style]="{ '--color': menuColor }"
    class="left"
    size="small"
    fill="clear"
    (click)="checkByQrCode()"
  >
    {{ "SHARED_TEXT.HEADER.CHECKED_IN_BY_QR_CODE" | translate }}</ion-button
  >

  <ion-button
    [style]="{ '--color': menuColor }"
    class="right"
    size="small"
    fill="clear"
    (click)="checkInByList()"
    >{{ "SHARED_TEXT.HEADER.CHECKED_IN_BY_LIST" | translate }}
  </ion-button>
</div>
